/**
 * @file Helpers related to BlueConic.
 */

import { wvusLogger } from "../observability/logging";

/**
 * Retrieves the BlueConic profile ID from `window.blueConicClient` if available.
 *
 * NOTE:
 *   - Does not throw errors; only logs an error and returns null.
 *   - Does not log an error if BlueConic is unavailable; only if BlueConic throws an error.
 *
 * @returns {string | null} The BlueConic profile ID if available, otherwise `null`.
 */
export function getBlueConicProfileId(): string | null {
  try {
    return window?.blueConicClient?.profile?.getProfile()?.getId();
  } catch (err) {
    wvusLogger.log(
      `Error retreiving blueconic profile id: ${err.message || ""}`,
      wvusLogger.getLogLevelNames().ERROR
    );
    return null;
  }
}
